module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"documents":"Documents","areyousure":"Are you sure?","yesdelete":"yes, delete!"},"de":{"documents":"Dokumente","areyousure":"Sind Sie sicher?","yesdelete":"Ja, löschen!"},"fr":{"documents":"Documents","areyousure":"Êtes-vous sûr ?","yesdelete":"Oui, supprimer !"},"it":{"documents":"Documenti","areyousure":"Sei sicuro?","yesdelete":"sì, cancella!"}}')
  delete Component.options._Ctor
}
